/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

import { STOCheckBasket, STOCheckBasketState } from 'commons/types';
import { ReducerKeys } from 'redux-stores/enums/reducerKey.enum';

const initialState: STOCheckBasketState = {
  stoCheckBasket: null,
};

const stoCheckBasketSlice = createSlice({
  name: ReducerKeys.STOCheckBasket,
  initialState,
  reducers: {
    setSTOCheckBasket(
      state: STOCheckBasketState,
      action: { type: string; payload: STOCheckBasket | null },
    ) {
      state.stoCheckBasket = action.payload;
    },
    setSTOCheckBasketPhotoUrls(
      state: STOCheckBasketState,
      action: { type: string; payload: STOCheckBasket | null },
    ) {
      if (action.payload && state.stoCheckBasket) {
        state.stoCheckBasket.photo_url = action.payload.photo_url;
      }
    },
    checkItem(
      state: STOCheckBasketState,
      action: {
        type: string;
        payload: { itemIndex: number; isChecked: boolean };
      },
    ) {
      const { payload } = action;
      if (state.stoCheckBasket) {
        state.stoCheckBasket.items[payload.itemIndex].pick_actual =
          state.stoCheckBasket.items[payload.itemIndex].pick_actual.map(
            (pickActual) => {
              if (pickActual.basket === state.stoCheckBasket?.basket) {
                return { ...pickActual, check_passed: payload.isChecked };
              } else {
                return pickActual;
              }
            },
          );
      }
    },
  },
});

export const { setSTOCheckBasket, setSTOCheckBasketPhotoUrls, checkItem } =
  stoCheckBasketSlice.actions;

export default stoCheckBasketSlice.reducer;
